var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _path22, _g22, _path23, _g23, _path24, _g24, _path25, _g25, _path26, _g26, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 40,
    viewBox: "0 0 156 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170018_15413)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_170018_15413)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 156,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156 0H0V40H156V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.997 0H9.74138H8.68055C7.90482 0.0096405 7.13097 0.068469 6.36542 0.176C5.60482 0.2861 4.86836 0.49472 4.18132 0.79467C3.49033 1.0966 2.85872 1.48888 2.30928 1.95737C1.75995 2.42606 1.30083 2.96607 0.948884 3.55737C0.593687 4.15286 0.347454 4.79137 0.218786 5.45067C0.0894746 6.10368 0.0206301 6.76437 0.0128611 7.42667C-0.00585941 7.73333 -0.00585937 8.032 -0.00585937 8.336V31.667C-0.00585937 31.9736 -0.00585941 32.2723 0.0128611 32.579C0.020891 33.2412 0.089739 33.9019 0.218786 34.555C0.346343 35.2049 0.589393 35.8344 0.939524 36.4216C1.6473 37.616 2.77869 38.5885 4.17196 39.2003C4.85924 39.5008 5.59554 39.7111 6.35606 39.8243C7.12168 39.931 7.89546 39.9889 8.67119 39.9976H9.73202H146.239H147.303C148.076 39.9895 148.848 39.9315 149.611 39.8243C150.379 39.7107 151.122 39.5004 151.818 39.2003C152.511 38.9015 153.142 38.5089 153.69 38.0376C154.241 37.5697 154.703 37.0296 155.057 36.4376C155.403 35.8497 155.644 35.2204 155.77 34.571C155.9 33.9178 155.972 33.2573 155.986 32.595V31.683V30.6163V9.4133V8.3466V7.43726C155.972 6.77493 155.9 6.11446 155.77 5.46126C155.643 4.8121 155.402 4.18296 155.057 3.59456C154.349 2.39676 153.22 1.41916 151.827 0.79986C151.131 0.50299 150.388 0.29714 149.621 0.18919C148.858 0.08107 148.086 0.02224 147.312 0.01319H146.249L144.997 0Z",
    fill: "#B6B6B6"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 156,
    height: 41
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156 0H0V40.0029H156V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75325 39.1388H8.70801C7.9847 39.1308 7.26303 39.0773 6.54896 38.9788C5.88423 38.8823 5.23981 38.7026 4.63631 38.4454C3.4375 37.9202 2.46099 37.0874 1.8438 36.0639C1.54009 35.5482 1.32969 34.9961 1.21978 34.4265C1.10048 33.8147 1.03685 33.1959 1.02946 32.5756C1.02946 32.3676 1.01074 31.6743 1.01074 31.6743V8.33659C1.01074 8.33659 1.01074 7.65388 1.02946 7.45387C1.03486 6.83281 1.09745 6.21308 1.21667 5.60044C1.32515 5.02879 1.53561 4.47476 1.84068 3.95762C2.14395 3.44879 2.54113 2.98504 3.01691 2.58422C3.49214 2.17761 4.03844 1.83662 4.63623 1.57345C5.23832 1.31582 5.88184 1.13607 6.54572 1.04008C7.26169 0.939445 7.98556 0.885061 8.71109 0.877411H147.301C148.019 0.88267 148.738 0.936172 149.447 1.03742C150.117 1.13144 150.768 1.31125 151.375 1.5708C152.577 2.10059 153.553 2.9404 154.164 3.97097C154.467 4.48413 154.678 5.03345 154.789 5.60039C154.909 6.21765 154.975 6.84158 154.988 7.46722V8.34728V9.41406V30.5886V31.6552V32.5753C154.978 33.1886 154.911 33.8001 154.792 34.4048C154.685 34.9785 154.474 35.5345 154.168 36.053C153.548 37.0726 152.573 37.9028 151.379 38.4291C150.773 38.689 150.123 38.8688 149.454 38.9625C148.739 39.0616 148.017 39.1151 147.294 39.1225H146.259H9.75125L9.75325 39.1388Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9728 27.0049H45.2818L44.143 30.1358H42.0815L46.6686 18.4389H48.6153L53.3063 30.1358H51.1489L49.9728 27.0049ZM45.8791 25.4048H49.3728L48.122 22.0552C47.9513 21.5938 47.7807 21.0818 47.6152 20.5218C47.4632 21.0178 47.2979 21.5218 47.1219 22.0392L45.8791 25.4048Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.136 23.5567C54.136 22.9112 54.1146 22.2001 54.072 21.4231H55.9388C56.009 21.7889 56.0571 22.1585 56.0828 22.5299C56.4095 22.1385 56.8169 21.8224 57.2773 21.6032C57.7376 21.384 58.2399 21.2671 58.7497 21.2605C59.3474 21.251 59.9343 21.42 60.4356 21.746C60.9367 22.0719 61.3293 22.5398 61.5633 23.0899C61.8913 23.8463 62.0471 24.6662 62.0192 25.4901C62.0395 26.3886 61.8573 27.2799 61.4859 28.0983C61.1752 28.7775 60.668 29.3479 60.0297 29.7357C59.3731 30.1153 58.6252 30.308 57.8669 30.2932C57.2703 30.2928 56.6779 30.1918 56.1148 29.9944V33.6027L54.12 33.7734L54.136 23.5567ZM59.379 28.0023C59.7844 27.469 59.9897 26.6689 59.9897 25.6021C59.9897 24.6297 59.8208 23.9184 59.483 23.4687C59.3304 23.2596 59.1294 23.0906 58.8972 22.9764C58.6649 22.8621 58.4083 22.8059 58.1496 22.8126C57.777 22.8076 57.4094 22.8995 57.0828 23.0792C56.7361 23.2758 56.4206 23.523 56.1468 23.8127V28.4796C56.3678 28.5838 56.6006 28.6608 56.8402 28.7091C57.0978 28.7648 57.3607 28.7934 57.6243 28.7944C57.959 28.8144 58.2937 28.7528 58.5993 28.6148C58.9051 28.4768 59.1726 28.2666 59.379 28.0023Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.2327 23.5567C63.2327 22.9112 63.2114 22.2001 63.1687 21.4231H65.0355C65.1078 21.7886 65.1568 22.1583 65.1822 22.5299C65.9591 21.6836 66.8481 21.2605 67.849 21.2605C68.4468 21.251 69.0337 21.42 69.535 21.746C70.0361 22.0719 70.4287 22.5398 70.6626 23.0899C70.9907 23.8463 71.1465 24.6662 71.1186 25.4901C71.1431 26.3875 70.9654 27.2789 70.5985 28.0983C70.2872 28.7779 69.779 29.3483 69.1398 29.7357C68.4833 30.1156 67.7353 30.3084 66.977 30.2932C66.3803 30.2928 65.788 30.1918 65.2248 29.9944V33.6027L63.2301 33.7734L63.2327 23.5567ZM68.4838 28.0023C68.8891 27.4565 69.0918 26.6564 69.0918 25.6021C69.0918 24.6297 68.9238 23.9184 68.5878 23.4687C68.4352 23.2596 68.2341 23.0906 68.0018 22.9764C67.7696 22.8621 67.5131 22.8059 67.2544 22.8126C66.8818 22.8081 66.5142 22.8999 66.1876 23.0792C65.8408 23.2758 65.5253 23.523 65.2516 23.8127V28.4796C65.4729 28.583 65.7056 28.66 65.9449 28.7091C66.2026 28.7648 66.4653 28.7934 66.729 28.7944C67.0637 28.814 67.3982 28.7522 67.7038 28.6141C68.0094 28.4762 68.2771 28.2663 68.4838 28.0023Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.7856 29.5831C73.9335 29.1158 73.2412 28.4031 72.7989 27.5377C72.3154 26.5597 72.0773 25.4787 72.1054 24.3881C72.0708 23.2213 72.347 22.0663 72.9055 21.0412C73.4098 20.1516 74.1674 19.4323 75.0817 18.9744C76.0426 18.5049 77.1006 18.2683 78.1699 18.2837C78.8184 18.2808 79.4649 18.3561 80.0954 18.5077C80.6851 18.6465 81.2575 18.8504 81.8021 19.1158L81.2848 20.6492C80.3414 20.1733 79.3036 19.9145 78.2473 19.8918C77.5016 19.8793 76.7658 20.0633 76.1137 20.4252C75.4951 20.7803 74.9978 21.3138 74.687 21.956C74.3295 22.7175 74.156 23.5525 74.1803 24.3934C74.167 25.1511 74.2992 25.9044 74.5696 26.6123C74.8152 27.2388 75.2471 27.775 75.8071 28.1484C76.445 28.5475 77.1887 28.7446 77.9406 28.7138C78.3302 28.7128 78.7191 28.6798 79.1033 28.615C79.4751 28.5559 79.8404 28.4613 80.194 28.3324V25.9536H77.4898V24.4041H82.1329V29.3351C81.4592 29.649 80.7538 29.8895 80.0287 30.0525C79.3098 30.2182 78.5744 30.3023 77.8365 30.3032C76.7747 30.3287 75.7241 30.0807 74.7856 29.5831Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2186 30.1352C89.1432 29.7543 89.0968 29.3683 89.0799 28.9805C88.7468 29.3681 88.3397 29.6853 87.8825 29.9138C87.3664 30.1753 86.7942 30.3071 86.2157 30.2979C85.7424 30.3039 85.2737 30.2027 84.845 30.0018C84.4371 29.8105 84.0961 29.5012 83.8662 29.1138C83.6114 28.6748 83.4849 28.173 83.5009 27.6657C83.4859 27.2809 83.5608 26.8978 83.7195 26.5469C83.8783 26.1961 84.1166 25.887 84.4156 25.6442C85.0236 25.1393 86.0379 24.8877 87.4585 24.8895C87.9876 24.8893 88.5161 24.9267 89.0399 25.0015V24.8308C89.0399 24.0627 88.8764 23.5205 88.5493 23.2041C88.1581 22.8675 87.6506 22.698 87.1358 22.732C86.6747 22.7376 86.2161 22.8003 85.7704 22.9186C85.3288 23.0251 84.8984 23.1734 84.485 23.3614L84.1702 21.9106C84.6225 21.7176 85.0922 21.5684 85.5731 21.4652C86.1777 21.3285 86.7958 21.2605 87.4158 21.2625C88.0726 21.2446 88.7262 21.3617 89.3359 21.6065C89.8723 21.8437 90.309 22.2606 90.5707 22.7853C90.898 23.4879 91.0507 24.2591 91.016 25.0335V28.5004C91.016 28.856 91.0374 29.4018 91.08 30.1379L89.2186 30.1352ZM88.0238 28.535C88.4083 28.3564 88.7536 28.1036 89.0399 27.791V26.1909C88.5973 26.1386 88.1522 26.1092 87.7065 26.1029C86.8833 26.1029 86.3135 26.2363 85.9971 26.5029C85.8427 26.6333 85.72 26.7971 85.6382 26.9819C85.5565 27.1667 85.5177 27.3678 85.525 27.5697C85.5105 27.7442 85.5338 27.9197 85.5931 28.0844C85.6526 28.2492 85.7466 28.3992 85.8691 28.5244C86.129 28.7437 86.4629 28.8553 86.8024 28.8365C87.2272 28.83 87.6449 28.727 88.0238 28.535Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.5569 28.045V17.7513L94.541 17.5913V27.691C94.5128 27.9713 94.5795 28.253 94.7304 28.491C94.8066 28.5729 94.9006 28.6364 95.005 28.6766C95.1094 28.7169 95.2217 28.7328 95.3331 28.7231C95.514 28.7153 95.6932 28.6847 95.8665 28.6323L96.1012 30.0618C95.8779 30.1462 95.6464 30.2069 95.4105 30.2432C95.1559 30.2873 94.8982 30.3105 94.6397 30.3125C93.2512 30.3036 92.5569 29.5473 92.5569 28.045Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.5203 28.045V17.7513L99.5071 17.5913V27.691C99.4788 27.9713 99.5455 28.253 99.6965 28.491C99.7725 28.5729 99.8665 28.6364 99.9705 28.6766C100.076 28.7169 100.188 28.7328 100.3 28.7231C100.48 28.7153 100.66 28.6847 100.833 28.6323L101.065 30.0618C100.843 30.1462 100.612 30.207 100.377 30.2432C100.121 30.2875 99.8625 30.3107 99.6035 30.3125C98.2163 30.3036 97.5221 29.5473 97.5203 28.045Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.222 26.0339H103.523C103.614 27.8598 104.483 28.7728 106.131 28.7728C106.554 28.7706 106.976 28.7205 107.387 28.6233C107.808 28.5255 108.219 28.3917 108.617 28.2233L109.054 29.5888C108.027 30.0726 106.903 30.3154 105.769 30.2982C104.956 30.3217 104.15 30.1381 103.427 29.7648C102.801 29.4264 102.299 28.8979 101.993 28.2553C101.654 27.511 101.49 26.6992 101.513 25.8818C101.49 25.0253 101.665 24.1751 102.022 23.3964C102.326 22.7354 102.819 22.1789 103.438 21.7963C104.072 21.4225 104.798 21.2324 105.534 21.2468C106.264 21.221 106.985 21.4233 107.595 21.8256C108.146 22.2076 108.572 22.7426 108.822 23.3644C109.097 24.0416 109.233 24.7671 109.222 25.4978V26.0339ZM107.278 24.7671C107.282 24.2009 107.094 23.6501 106.745 23.2044C106.588 23.029 106.395 22.8903 106.179 22.7981C105.963 22.706 105.729 22.6625 105.494 22.6709C105.258 22.6661 105.023 22.711 104.805 22.8029C104.587 22.8948 104.391 23.0316 104.23 23.2044C103.854 23.6424 103.624 24.1868 103.571 24.7618L107.278 24.7671Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.732 23.6127C110.732 23.1353 110.708 22.4046 110.666 21.4258H112.532C112.564 21.6685 112.594 21.9592 112.626 22.2926C112.658 22.6259 112.674 22.9032 112.684 23.114C112.885 22.774 113.113 22.4512 113.367 22.1486C113.587 21.89 113.853 21.6738 114.152 21.5111C114.465 21.3419 114.817 21.2565 115.173 21.2631C115.443 21.2565 115.713 21.2898 115.973 21.3618L115.723 23.09C115.41 22.9995 115.082 22.9765 114.761 23.0225C114.439 23.0685 114.13 23.1825 113.855 23.3567C113.414 23.6847 113.029 24.0829 112.716 24.5354V30.1358H110.732V23.6127Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.083 33.7014C116.839 33.662 116.6 33.6041 116.365 33.528L116.728 32.0746C116.896 32.1198 117.066 32.1562 117.237 32.1839C117.429 32.218 117.624 32.2359 117.819 32.2373C118.707 32.2373 119.369 31.6693 119.803 30.5332L119.933 30.2105L116.72 21.4258H118.853L120.485 26.3355C120.694 26.967 120.863 27.611 120.992 28.2636C121.144 27.6343 121.32 27.0049 121.525 26.3755L123.152 21.4258H125.16L121.96 30.2505C121.718 30.9613 121.39 31.6394 120.981 32.2693C120.67 32.745 120.244 33.1356 119.744 33.4054C119.207 33.6673 118.615 33.7954 118.019 33.7787C117.705 33.7799 117.392 33.754 117.083 33.7014Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0813 7.30182H45.6283L45.5295 8.16055H43.1161V9.82197H45.3908V10.622H43.1161V12.4621H45.6576L45.5695 13.3342H42.0813V7.30182Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0796 10.2567L46.2128 7.30182H47.3968L48.6662 9.47268L49.9996 7.30182H51.1491L49.2823 10.2194L51.3011 13.3343H50.101L48.6635 10.9608L47.1994 13.3343H46.05L48.0796 10.2567Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.0659 7.30182H53.6927C54.4554 7.30182 55.0403 7.45739 55.4475 7.76853C55.65 7.92787 55.8111 8.13376 55.9169 8.36871C56.0228 8.60365 56.0703 8.86068 56.0555 9.11795C56.0668 9.48542 55.9744 9.84864 55.7889 10.166C55.6078 10.4644 55.3437 10.7036 55.0288 10.8541C54.679 11.0195 54.2956 11.1016 53.9088 11.0941C53.6401 11.0903 53.3724 11.0627 53.1087 11.0115V13.3343H52.0659V7.30182ZM54.6794 9.99531C54.7932 9.88606 54.8819 9.75342 54.9395 9.60655C54.997 9.45968 55.022 9.30206 55.0128 9.14459C55.0263 8.99367 55.0025 8.84174 54.9435 8.70221C54.8844 8.56267 54.7919 8.43983 54.6741 8.34454C54.374 8.16174 54.0247 8.07606 53.674 8.09918H53.1087V10.2326C53.3068 10.2683 53.5074 10.2888 53.7087 10.2939C54.0584 10.3202 54.405 10.2136 54.6794 9.99531Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0854 7.30182H58.1255V12.4436H60.6217L60.5337 13.3343H57.0854V7.30182Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.2057 13.0379C61.7686 12.792 61.4156 12.4204 61.1923 11.9713C60.9497 11.4734 60.8299 10.9248 60.843 10.3711C60.8302 9.79259 60.9583 9.21966 61.2163 8.70162C61.4529 8.23472 61.8246 7.84995 62.2831 7.59754C62.7963 7.32871 63.3708 7.19819 63.9498 7.21885C64.4974 7.20415 65.0391 7.33384 65.5206 7.59487C65.9551 7.84169 66.3054 8.21334 66.526 8.66165C66.7638 9.15427 66.8817 9.69622 66.87 10.2432C66.8845 10.8281 66.7554 11.4077 66.494 11.9313C66.2553 12.3965 65.8841 12.7807 65.4273 13.0354C64.923 13.3036 64.3583 13.4377 63.7872 13.4247C63.235 13.4387 62.6891 13.3052 62.2057 13.0379ZM64.9046 12.2993C65.1986 12.1045 65.4271 11.8256 65.5606 11.4992C65.7103 11.1255 65.7838 10.7256 65.7767 10.3231C65.7834 9.92799 65.7183 9.53492 65.5847 9.16305C65.4649 8.84094 65.2512 8.5622 64.9713 8.363C64.6465 8.16429 64.2733 8.05915 63.8925 8.05915C63.5118 8.05915 63.1385 8.16429 62.8138 8.363C62.5189 8.56754 62.2893 8.85272 62.1524 9.1844C62.0007 9.54271 61.9253 9.92873 61.931 10.3178C61.9246 10.7187 61.9952 11.117 62.1391 11.4913C62.2668 11.8336 62.5004 12.1263 62.8059 12.3268C63.1115 12.5272 63.4729 12.625 63.8378 12.6059C64.2164 12.6153 64.5888 12.5082 64.9046 12.2993Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.03 7.30182H69.9182C70.4713 7.26267 71.0218 7.40804 71.4836 7.71519C71.6607 7.85427 71.8017 8.03405 71.8946 8.23926C71.9874 8.44446 72.0294 8.66905 72.0169 8.89394C72.0232 9.18637 71.9572 9.47582 71.8249 9.73667C71.7092 9.96539 71.5476 10.1678 71.3503 10.3314C71.1738 10.4738 70.9757 10.5873 70.7635 10.6674L72.6304 13.3342H71.4169L69.8462 10.9341H69.0807V13.3342H68.03V7.30182ZM69.6647 10.1554C69.8964 10.1604 70.1259 10.1101 70.3342 10.0087C70.5217 9.91863 70.6799 9.77714 70.7902 9.60069C70.9002 9.41234 70.9565 9.19742 70.9528 8.97931C70.9636 8.85342 70.9429 8.72684 70.8926 8.61094C70.8423 8.49504 70.7641 8.39343 70.6648 8.31526C70.4148 8.15873 70.1218 8.08501 69.8275 8.10458H69.0727V10.166L69.6647 10.1554Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.4436 7.30182H76.9986L76.8972 8.16055H74.4971V9.82197H76.7505V10.622H74.4757V12.4621H77.0173L76.9399 13.3342H73.4436V7.30182Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.866 7.30182H81.906V13.3343H80.866V7.30182Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.6603 8.17128H82.7935L82.8842 7.30189H87.5778L87.4818 8.17128H85.7031V13.3343H84.6603V8.17128Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.0988 13.0379C91.6626 12.7918 91.3104 12.4202 91.0882 11.9713C90.8434 11.4741 90.7225 10.9251 90.7361 10.3711C90.7233 9.79259 90.8515 9.21966 91.1095 8.70162C91.3467 8.2352 91.7182 7.85061 92.1762 7.59754C92.6856 7.32738 93.256 7.19327 93.8324 7.20817C94.3863 7.19326 94.9341 7.32677 95.4191 7.59487C95.8542 7.8409 96.2046 8.21276 96.4246 8.66165C96.6633 9.15404 96.7821 9.69592 96.7712 10.2432C96.7861 10.8284 96.656 11.4083 96.3925 11.9313C96.1545 12.3971 95.7832 12.7814 95.3258 13.0354C94.8217 13.3043 94.2568 13.4384 93.6857 13.4247C93.1317 13.4396 92.5839 13.306 92.0988 13.0379ZM94.8004 12.2993C95.093 12.1036 95.3205 11.8249 95.4538 11.4992C95.6034 11.1255 95.6769 10.7256 95.6698 10.3231C95.6765 9.92798 95.6114 9.53492 95.4778 9.16305C95.3592 8.84112 95.1464 8.56235 94.867 8.363C94.5419 8.16406 94.1682 8.05879 93.787 8.05879C93.4058 8.05879 93.0321 8.16406 92.7069 8.363C92.4121 8.56754 92.1824 8.85272 92.0455 9.18439C91.8951 9.54309 91.8197 9.92884 91.8242 10.3178C91.8178 10.7187 91.8884 11.117 92.0322 11.4913C92.1594 11.8202 92.3813 12.1041 92.6696 12.3073C92.9853 12.5156 93.3583 12.6201 93.7364 12.6059C94.1139 12.6137 94.4849 12.5068 94.8004 12.2993Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.9253 7.30182H99.1201L102.104 11.9769C102.077 11.5315 102.067 11.1235 102.067 10.7475V7.30182H103.032V13.3343H101.875L98.8454 8.58461C98.8748 9.11798 98.8908 9.60069 98.8908 10.0194V13.3343H97.9253V7.30182Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4141 7.33382H16.3443C11.1253 7.33382 9.21582 9.24326 9.21582 14.4623V25.5401C9.21582 30.7591 11.1253 32.6686 16.3443 32.6686H27.4141C32.6332 32.6686 34.5453 30.7591 34.5453 25.5401V14.4623C34.5506 9.24336 32.6412 7.33382 27.4141 7.33382Z",
    fill: "#C8102E"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_170018_15413)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 41
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 0H0.478516V40.0029H133.818V0Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2312 20.0014H14.9033V23.3164H14.2312V21.9696H12.7138V23.3164H12.0417V20.0014H12.7138V21.3348H14.2312V20.0014ZM18.0182 21.8976C18.0182 22.4309 17.7515 22.7243 17.2661 22.7243C16.7808 22.7243 16.5088 22.4309 16.5088 21.8683V20.0014H15.8367V21.8949C15.8367 22.8256 16.3541 23.359 17.2554 23.359C18.1569 23.359 18.6902 22.8256 18.6902 21.8656V20.0014H18.0182V21.8976ZM25.784 22.2789L25.032 20.0014H24.4799L23.7333 22.2816L22.9998 20.0014H22.2852L23.4399 23.3164H23.9973L24.7467 21.1402L25.4987 23.3164H26.0615L27.2161 20.0014H26.5175L25.784 22.2789ZM28.4189 21.8869H29.643V21.2868H28.4189V20.6095H30.195V20.0014H27.7576V23.3084H30.259V22.7109H28.4189V21.8869ZM31.0591 23.3084H31.7232V20.0014H31.0591V23.3084ZM20.0183 22.6229L19.717 23.311H19.0315L20.4797 20.0014H21.0717L22.5252 23.311H21.8317L21.5464 22.6256L20.0183 22.6229ZM20.269 22.0256H21.2797L20.7731 20.8415L20.269 22.0256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 6,
    width: 66,
    height: 8,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5391 10.9004V10.7656C41.5391 10.3086 41.6055 9.88477 41.7383 9.49414C41.8711 9.09961 42.0625 8.75781 42.3125 8.46875C42.5625 8.17578 42.8652 7.94922 43.2207 7.78906C43.5762 7.625 43.9746 7.54297 44.416 7.54297C44.8613 7.54297 45.2617 7.625 45.6172 7.78906C45.9766 7.94922 46.2812 8.17578 46.5312 8.46875C46.7852 8.75781 46.9785 9.09961 47.1113 9.49414C47.2441 9.88477 47.3105 10.3086 47.3105 10.7656V10.9004C47.3105 11.3574 47.2441 11.7812 47.1113 12.1719C46.9785 12.5625 46.7852 12.9043 46.5312 13.1973C46.2812 13.4863 45.9785 13.7129 45.623 13.877C45.2715 14.0371 44.873 14.1172 44.4277 14.1172C43.9824 14.1172 43.582 14.0371 43.2266 13.877C42.8711 13.7129 42.5664 13.4863 42.3125 13.1973C42.0625 12.9043 41.8711 12.5625 41.7383 12.1719C41.6055 11.7812 41.5391 11.3574 41.5391 10.9004ZM42.623 10.7656V10.9004C42.623 11.2168 42.6602 11.5156 42.7344 11.7969C42.8086 12.0742 42.9199 12.3203 43.0684 12.5352C43.2207 12.75 43.4102 12.9199 43.6367 13.0449C43.8633 13.166 44.127 13.2266 44.4277 13.2266C44.7246 13.2266 44.9844 13.166 45.207 13.0449C45.4336 12.9199 45.6211 12.75 45.7695 12.5352C45.918 12.3203 46.0293 12.0742 46.1035 11.7969C46.1816 11.5156 46.2207 11.2168 46.2207 10.9004V10.7656C46.2207 10.4531 46.1816 10.1582 46.1035 9.88086C46.0293 9.59961 45.916 9.35156 45.7637 9.13672C45.6152 8.91797 45.4277 8.74609 45.2012 8.62109C44.9785 8.49609 44.7168 8.43359 44.416 8.43359C44.1191 8.43359 43.8574 8.49609 43.6309 8.62109C43.4082 8.74609 43.2207 8.91797 43.0684 9.13672C42.9199 9.35156 42.8086 9.59961 42.7344 9.88086C42.6602 10.1582 42.623 10.4531 42.623 10.7656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.125 7.66016V14H50.0352V7.66016H51.125ZM53.252 7.66016V8.53906H47.9492V7.66016H53.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4961 7.66016V14H54.4121V7.66016H55.4961ZM59.6562 7.66016L56.6504 11.293H55.1328L54.9688 10.3438H56.2109L58.3379 7.66016H59.6562ZM58.4902 14L56.1582 11.1289L56.8555 10.3438L59.8672 14H58.4902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8945 8.87891V16.4375H60.8047V7.66016H61.8008L61.8945 8.87891ZM66.166 10.7773V10.9004C66.166 11.3613 66.1113 11.7891 66.002 12.1836C65.8926 12.5742 65.7324 12.9141 65.5215 13.2031C65.3145 13.4922 65.0586 13.7168 64.7539 13.877C64.4492 14.0371 64.0996 14.1172 63.7051 14.1172C63.3027 14.1172 62.9473 14.0508 62.6387 13.918C62.3301 13.7852 62.0684 13.5918 61.8535 13.3379C61.6387 13.084 61.4668 12.7793 61.3379 12.4238C61.2129 12.0684 61.127 11.668 61.0801 11.2227V10.5664C61.127 10.0977 61.2148 9.67773 61.3438 9.30664C61.4727 8.93555 61.6426 8.61914 61.8535 8.35742C62.0684 8.0918 62.3281 7.89062 62.6328 7.75391C62.9375 7.61328 63.2891 7.54297 63.6875 7.54297C64.0859 7.54297 64.4395 7.62109 64.748 7.77734C65.0566 7.92969 65.3164 8.14844 65.5273 8.43359C65.7383 8.71875 65.8965 9.06055 66.002 9.45898C66.1113 9.85352 66.166 10.293 66.166 10.7773ZM65.0762 10.9004V10.7773C65.0762 10.4609 65.043 10.1641 64.9766 9.88672C64.9102 9.60547 64.8066 9.35938 64.666 9.14844C64.5293 8.93359 64.3535 8.76562 64.1387 8.64453C63.9238 8.51953 63.668 8.45703 63.3711 8.45703C63.0977 8.45703 62.8594 8.50391 62.6562 8.59766C62.457 8.69141 62.2871 8.81836 62.1465 8.97852C62.0059 9.13477 61.8906 9.31445 61.8008 9.51758C61.7148 9.7168 61.6504 9.92383 61.6074 10.1387V11.6562C61.6855 11.9297 61.7949 12.1875 61.9355 12.4297C62.0762 12.668 62.2637 12.8613 62.498 13.0098C62.7324 13.1543 63.0273 13.2266 63.3828 13.2266C63.6758 13.2266 63.9277 13.166 64.1387 13.0449C64.3535 12.9199 64.5293 12.75 64.666 12.5352C64.8066 12.3203 64.9102 12.0742 64.9766 11.7969C65.043 11.5156 65.0762 11.2168 65.0762 10.9004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2617 10.9004V10.7656C67.2617 10.3086 67.3281 9.88477 67.4609 9.49414C67.5938 9.09961 67.7852 8.75781 68.0352 8.46875C68.2852 8.17578 68.5879 7.94922 68.9434 7.78906C69.2988 7.625 69.6973 7.54297 70.1387 7.54297C70.584 7.54297 70.9844 7.625 71.3398 7.78906C71.6992 7.94922 72.0039 8.17578 72.2539 8.46875C72.5078 8.75781 72.7012 9.09961 72.834 9.49414C72.9668 9.88477 73.0332 10.3086 73.0332 10.7656V10.9004C73.0332 11.3574 72.9668 11.7812 72.834 12.1719C72.7012 12.5625 72.5078 12.9043 72.2539 13.1973C72.0039 13.4863 71.7012 13.7129 71.3457 13.877C70.9941 14.0371 70.5957 14.1172 70.1504 14.1172C69.7051 14.1172 69.3047 14.0371 68.9492 13.877C68.5938 13.7129 68.2891 13.4863 68.0352 13.1973C67.7852 12.9043 67.5938 12.5625 67.4609 12.1719C67.3281 11.7812 67.2617 11.3574 67.2617 10.9004ZM68.3457 10.7656V10.9004C68.3457 11.2168 68.3828 11.5156 68.457 11.7969C68.5312 12.0742 68.6426 12.3203 68.791 12.5352C68.9434 12.75 69.1328 12.9199 69.3594 13.0449C69.5859 13.166 69.8496 13.2266 70.1504 13.2266C70.4473 13.2266 70.707 13.166 70.9297 13.0449C71.1562 12.9199 71.3438 12.75 71.4922 12.5352C71.6406 12.3203 71.752 12.0742 71.8262 11.7969C71.9043 11.5156 71.9434 11.2168 71.9434 10.9004V10.7656C71.9434 10.4531 71.9043 10.1582 71.8262 9.88086C71.752 9.59961 71.6387 9.35156 71.4863 9.13672C71.3379 8.91797 71.1504 8.74609 70.9238 8.62109C70.7012 8.49609 70.4395 8.43359 70.1387 8.43359C69.8418 8.43359 69.5801 8.49609 69.3535 8.62109C69.1309 8.74609 68.9434 8.91797 68.791 9.13672C68.6426 9.35156 68.5312 9.59961 68.457 9.88086C68.3828 10.1582 68.3457 10.4531 68.3457 10.7656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5645 12.2832L78.4883 7.66016H79.5781V14H78.4883V9.37695L75.5645 14H74.4863V7.66016H75.5645V12.2832ZM77.8965 5.36328H78.7754C78.7754 5.66797 78.7051 5.93945 78.5645 6.17773C78.4238 6.41211 78.2227 6.5957 77.9609 6.72852C77.6992 6.86133 77.3887 6.92773 77.0293 6.92773C76.4863 6.92773 76.0566 6.7832 75.7402 6.49414C75.4277 6.20117 75.2715 5.82422 75.2715 5.36328H76.1504C76.1504 5.59375 76.2168 5.79688 76.3496 5.97266C76.4824 6.14844 76.709 6.23633 77.0293 6.23633C77.3418 6.23633 77.5645 6.14844 77.6973 5.97266C77.8301 5.79688 77.8965 5.59375 77.8965 5.36328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9023 7.66016V14H82.8125V7.66016H83.9023ZM86.0293 7.66016V8.53906H80.7266V7.66016H86.0293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2578 14.1172C88.8164 14.1172 88.416 14.043 88.0566 13.8945C87.7012 13.7422 87.3945 13.5293 87.1367 13.2559C86.8828 12.9824 86.6875 12.6582 86.5508 12.2832C86.4141 11.9082 86.3457 11.498 86.3457 11.0527V10.8066C86.3457 10.291 86.4219 9.83203 86.5742 9.42969C86.7266 9.02344 86.9336 8.67969 87.1953 8.39844C87.457 8.11719 87.7539 7.9043 88.0859 7.75977C88.418 7.61523 88.7617 7.54297 89.1172 7.54297C89.5703 7.54297 89.9609 7.62109 90.2891 7.77734C90.6211 7.93359 90.8926 8.15234 91.1035 8.43359C91.3145 8.71094 91.4707 9.03906 91.5723 9.41797C91.6738 9.79297 91.7246 10.2031 91.7246 10.6484V11.1348H86.9902V10.25H90.6406V10.168C90.625 9.88672 90.5664 9.61328 90.4648 9.34766C90.3672 9.08203 90.2109 8.86328 89.9961 8.69141C89.7812 8.51953 89.4883 8.43359 89.1172 8.43359C88.8711 8.43359 88.6445 8.48633 88.4375 8.5918C88.2305 8.69336 88.0527 8.8457 87.9043 9.04883C87.7559 9.25195 87.6406 9.5 87.5586 9.79297C87.4766 10.0859 87.4355 10.4238 87.4355 10.8066V11.0527C87.4355 11.3535 87.4766 11.6367 87.5586 11.9023C87.6445 12.1641 87.7676 12.3945 87.9277 12.5938C88.0918 12.793 88.2891 12.9492 88.5195 13.0625C88.7539 13.1758 89.0195 13.2324 89.3164 13.2324C89.6992 13.2324 90.0234 13.1543 90.2891 12.998C90.5547 12.8418 90.7871 12.6328 90.9863 12.3711L91.6426 12.8926C91.5059 13.0996 91.332 13.2969 91.1211 13.4844C90.9102 13.6719 90.6504 13.8242 90.3418 13.9414C90.0371 14.0586 89.6758 14.1172 89.2578 14.1172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9434 11.2109H96.8633L96.8516 10.3438H98.5508C98.8867 10.3438 99.166 10.3105 99.3887 10.2441C99.6152 10.1777 99.7852 10.0781 99.8984 9.94531C100.012 9.8125 100.068 9.64844 100.068 9.45312C100.068 9.30078 100.035 9.16797 99.9688 9.05469C99.9062 8.9375 99.8105 8.8418 99.6816 8.76758C99.5527 8.68945 99.3926 8.63281 99.2012 8.59766C99.0137 8.55859 98.793 8.53906 98.5391 8.53906H97.1504V14H96.0664V7.66016H98.5391C98.9414 7.66016 99.3027 7.69531 99.623 7.76562C99.9473 7.83594 100.223 7.94336 100.449 8.08789C100.68 8.22852 100.855 8.4082 100.977 8.62695C101.098 8.8457 101.158 9.10352 101.158 9.40039C101.158 9.5918 101.119 9.77344 101.041 9.94531C100.963 10.1172 100.848 10.2695 100.695 10.4023C100.543 10.5352 100.355 10.6445 100.133 10.7305C99.9102 10.8125 99.6543 10.8652 99.3652 10.8887L98.9434 11.2109ZM98.9434 14H96.4707L97.0098 13.1211H98.9434C99.2441 13.1211 99.4941 13.084 99.6934 13.0098C99.8926 12.9316 100.041 12.8223 100.139 12.6816C100.24 12.5371 100.291 12.3652 100.291 12.166C100.291 11.9668 100.24 11.7969 100.139 11.6562C100.041 11.5117 99.8926 11.4023 99.6934 11.3281C99.4941 11.25 99.2441 11.2109 98.9434 11.2109H97.2969L97.3086 10.3438H99.3652L99.7578 10.6719C100.105 10.6992 100.4 10.7852 100.643 10.9297C100.885 11.0742 101.068 11.2578 101.193 11.4805C101.318 11.6992 101.381 11.9375 101.381 12.1953C101.381 12.4922 101.324 12.7539 101.211 12.9805C101.102 13.207 100.941 13.3965 100.73 13.5488C100.52 13.6973 100.264 13.8105 99.9629 13.8887C99.6621 13.9629 99.3223 14 98.9434 14Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_170018_15413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 156,
    height: 40
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M156 0H0V40H156V0Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_170018_15413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8828 15.7851C20.7647 15.7844 19.6927 15.34 18.9022 14.5494C18.1116 13.7589 17.6672 12.6868 17.6665 11.5688H18.2611C18.2611 12.5293 18.6428 13.4505 19.3219 14.1297C20.0011 14.8089 20.9222 15.1904 21.8828 15.1904C22.8433 15.1904 23.7644 14.8089 24.4436 14.1297C25.1228 13.4505 25.5044 12.5293 25.5044 11.5688H26.0991C26.0984 12.6868 25.654 13.7589 24.8634 14.5494C24.0729 15.34 23.0008 15.7844 21.8828 15.7851Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170018_15413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_170018_15413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_170018_15413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 133.34,
    height: 40.0029,
    fill: "white",
    transform: "translate(0.478516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRu);
export default __webpack_public_path__ + "static/media/ru.a79bbf522dd170b2d316182665dc4383.svg";
export { ForwardRef as ReactComponent };